
const Logo = () => {
    return (<svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#27485C]">
        <path d="M9.45675 17.9226C8.30698 18.0988 7.20809 17.2958 7.29225 16.1286C7.33917 15.4777 7.45289 14.8316 7.63273 14.2007C8.00688 12.8882 8.6584 11.6725 9.54271 10.6368C10.427 9.60106 11.5232 8.76981 12.7564 8.19989C13.9895 7.62998 15.3305 7.33485 16.6874 7.3347C18.0444 7.33455 19.3854 7.62939 20.6187 8.19904C21.8519 8.76868 22.9483 9.5997 23.8329 10.6352C24.7174 11.6707 25.3692 12.8863 25.7436 14.1988C25.9236 14.8296 26.0375 15.4757 26.0845 16.1266C26.1689 17.2938 25.0702 18.0969 23.9204 17.921C22.7706 17.7451 22.0229 16.6336 21.7314 15.5006C21.72 15.4563 21.708 15.4122 21.6955 15.3682C21.4884 14.6424 21.128 13.9703 20.6389 13.3977C20.1498 12.8251 19.5436 12.3656 18.8617 12.0506C18.1797 11.7357 17.4382 11.5726 16.6879 11.5727C15.9376 11.5728 15.1961 11.736 14.5142 12.0511C13.8324 12.3662 13.2262 12.8259 12.7373 13.3986C12.2483 13.9713 11.888 14.6435 11.6811 15.3693C11.6686 15.4133 11.6566 15.4574 11.6452 15.5017C11.354 16.6347 10.6065 17.7464 9.45675 17.9226Z" fill="currentColor" />
        <path d="M0 16.1103C0 15.0931 0.819475 14.2685 1.83035 14.2685H3.66069C4.67157 14.2685 5.49104 15.0931 5.49104 16.1103C5.49104 17.1275 4.67157 17.9521 3.66069 17.9521H1.83035C0.819473 17.9521 0 17.1275 0 16.1103Z" fill="currentColor" />
        <path d="M27.8859 16.1102C27.8859 15.0931 28.7053 14.2685 29.7162 14.2685H31.5466C32.5574 14.2685 33.3769 15.0931 33.3769 16.1102C33.3769 17.1274 32.5574 17.952 31.5466 17.952H29.7162C28.7053 17.952 27.8859 17.1274 27.8859 16.1102Z" fill="currentColor" />
        <path d="M16.9038 5.52539C15.8929 5.52539 15.0734 4.70079 15.0734 3.68359V1.8418C15.0734 0.824599 15.8929 0 16.9038 0C17.9147 0 18.7341 0.824601 18.7341 1.8418V3.68359C18.7341 4.70079 17.9147 5.52539 16.9038 5.52539Z" fill="currentColor" />
        <path d="M23.0647 6.8653C22.1893 6.3567 21.8893 5.23027 22.3948 4.34936L23.31 2.75431C23.8154 1.8734 24.9348 1.57157 25.8103 2.08017C26.6857 2.58877 26.9856 3.71519 26.4802 4.59611L25.565 6.19115C25.0596 7.07207 23.9402 7.37389 23.0647 6.8653Z" fill="currentColor" />
        <path d="M26.7554 10.934C26.2499 10.0531 26.5499 8.92667 27.4253 8.41807L29.0104 7.49717C29.8859 6.98857 31.0053 7.2904 31.5107 8.17132C32.0162 9.05223 31.7162 10.1787 30.8408 10.6873L29.2557 11.6082C28.3802 12.1168 27.2608 11.8149 26.7554 10.934Z" fill="currentColor" />
        <path d="M2.34715 8.17132C2.85259 7.2904 3.97201 6.98857 4.84745 7.49717L6.43258 8.41807C7.30802 8.92667 7.60797 10.0531 7.10253 10.934C6.59709 11.8149 5.47767 12.1167 4.60223 11.6082L3.0171 10.6873C2.14166 10.1787 1.84171 9.05223 2.34715 8.17132Z" fill="currentColor" />
        <path d="M7.99139 2.08015C8.86683 1.57155 9.98625 1.87338 10.4917 2.75429L11.4069 4.34934C11.9123 5.23025 11.6124 6.35668 10.7369 6.86528C9.86147 7.37387 8.74204 7.07205 8.23661 6.19113L7.32143 4.59609C6.816 3.71517 7.11595 2.58875 7.99139 2.08015Z" fill="currentColor" />
    </svg>)

}


export const AboutUs = () => {
    return (
        <div className="w-full lg:h-full max-h-[600px] lg:max-h-[80vh] flex flex-col gap-8 p-2 lg:p-4 lg:pb-6">
             <div className="flex gap-2 items-center justify-center w-full">
                <Logo/>
            </div>

            <div className="flex flex-col py-4 pb-20 lg:pb-0 h-full overflow-y-auto pr-2 text-base-text text-[14px] font-light">
                <p>aomeを訪れてくれた、あなたへ。</p>

                <p className="mt-8">グレイソンと、アナスタシアです。</p>
                <p>アメリカとウクライナから来た23歳と20歳の夫婦が、日本でaomeを創りました。</p>

                <p className="mt-8">作り始めてから、ずっと考え続けている問いがあります。</p>
                <p className="ml-4">「言葉ってなんですか。</p>
                <p className="ml-4">学ぶってなんですか。」</p>

                <p className="mt-8">英語を、何度も諦めかけたことがあるかもしれません。</p>
                <p>単語も、文法も、覚えた。それでも、話せなかった。</p>

                <p className="mt-8"> それは、あなたのせいじゃなかった。</p>

                <p className="mt-8">あなたの中にある深さが、英語ではまだ、そのまま出てこないだけです。</p>

                <p className="mt-8">英語の中には、美しいものがたくさんあります。</p>
                <p>誰かが、誰かに伝えたくてつくったものが。</p>
                
                <p className="mt-8">私たちが作れるのは、場所だけです。</p>

                <p className="mt-8">そこで何を感じ、何を見つけるかは、あなたにしかわかりません。</p>

                <p className="mt-8">その道に、終わりはありません。ネイティブスピーカーであっても同じです。</p>
                <p>ただ、少し早く、少し違う場所から、歩き始めただけ。</p>

                <p className="mt-8">同じ道を、一緒に歩けたら嬉しいです。</p>

                <p className="mt-8 w-full text-end">グレイソン & アナスタシア</p>
            </div>
        </div>
    )
}